module.exports = __webpack_public_path__ + "static/media/Kuma 2.d893263d.jpg";